import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
  timeout: 30000  // 30 seconds for payment operations
});

// Simple retry with exponential backoff for rate limits
apiClient.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    const requestId = error.response?.headers?.['x-request-id'];
    
    if (requestId) {
      console.error(`API Error [RequestID: ${requestId}]:`, error.message);
      error.requestId = requestId;
    }
    
    // Handle rate limiting (429) with exponential backoff
    if (error.response?.status === 429 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Get retry delay from header or use default
      const retryAfter = error.response.headers['retry-after'];
      const delay = retryAfter ? parseInt(retryAfter) * 1000 : 2000;
      
      console.warn(`Rate limited. Retrying after ${delay}ms...`);
      
      // Wait then retry
      await new Promise(resolve => setTimeout(resolve, delay));
      return apiClient(originalRequest);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
